const categories = [
  { icon: 'ri-movie-2-line', label: '动作大片', desc: '热血刺激' },
  { icon: 'ri-heart-pulse-line', label: '爱情剧场', desc: '甜蜜浪漫' },
  { icon: 'ri-emotion-laugh-line', label: '喜剧专区', desc: '爆笑不断' },
  { icon: 'ri-ghost-line', label: '悬疑推理', desc: '烧脑反转' },
  { icon: 'ri-rocket-line', label: '科幻世界', desc: '脑洞大开' },
  { icon: 'ri-sword-line', label: '古装武侠', desc: '江湖风云' },
  { icon: 'ri-parent-line', label: '家庭伦理', desc: '温情催泪' },
  { icon: 'ri-tv-2-line', label: '综艺娱乐', desc: '轻松解压' },
  { icon: 'ri-earth-line', label: '海外剧集', desc: '全球视野' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            热门分类索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按喜好快速找到你想看的影视类型
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <div className="text-center">
                <div className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                  {item.label}
                </div>
                <div className="text-xs text-foreground-400 mt-1">
                  {item.desc}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}